import { ChangeDetectionStrategy, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FeatureFlagService } from '@core/feature';
import { CustomOrder } from '@order/const';
import { OrderService } from '@order/feature';
import { combineLatest, filter, ReplaySubject } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'sd-order-repeat-button',
  templateUrl: './order-repeat-button.component.html',
  styleUrls: ['./order-repeat-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdOrderRepeatButtonComponent implements OnInit {
  order$ = new ReplaySubject<CustomOrder>(1);
  loading$ = this.orderService.repeatOrderLoadingState();

  showRepeatButton$ = combineLatest({
    order: this.order$.pipe(filter(Boolean)),
    isRepeatOfflineOrderEnabled: this.featureFlagService.isEnabled('isRepeatOfflineOrderEnabled'),
  }).pipe(map(({ order, isRepeatOfflineOrderEnabled }) => !order.isOfflineOrder || isRepeatOfflineOrderEnabled));

  constructor(
    private orderService: OrderService,
    private featureFlagService: FeatureFlagService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.orderService
      .getOrderDetails()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((orderDetails: CustomOrder) => {
        this.order$.next(orderDetails);
      });
  }

  repeatOrder(): void {
    this.order$.pipe(take(1)).subscribe((order) => {
      this.orderService.repeatOrder(order.code);
    });
  }
}
